import '../stylesheets/charts.scss';
import Turbolinks from 'turbolinks';
import 'charts';
Turbolinks.start();